import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import { Link } from "react-router-dom";

// @material-ui/icons
import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";
import AccountBalance from "@material-ui/icons/AccountBalance";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Success from "components/Typography/Success.jsx";
import Danger from "components/Typography/Danger.jsx";

import pricingStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/pricingStyle.jsx";

import bg11 from "assets/img/bg11.jpg";


function SectionPricing({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      {/* Pricing 1 START */}
      <div
        className={`${classes.pricing} ${classes.pricing1} ${classes.section}`}
        style={{ backgroundImage: `url(${bg11})` }}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={6}
              md={6}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>Corporates, investors & developers</h2>
              <h5 className={classes.description}>
                Services to international investors
              </h5>
              <div className={classes.sectionSpace} />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6} lg={3}>
              <Card pricing plain>
                <CardBody pricing plain>
                  <h6
                    className={`${classes.cardCategory} ${
                      classes.marginBottom20
                    }`}
                  >
                    HONESTY
                  </h6>
                  <div className={classes.icon}>
                    <Weekend className={classes.iconWhite} />
                  </div>
                  <h3
                    className={`${classes.cardTitleWhite} ${
                      classes.marginTop30
                    }`}
                  >
                    Broker
                  </h3>
                  <p className={classes.cardCategory}>
                    RECOGNISE & ENHANCE REAL ESTATE VALUES
                  </p>
                  <Link to="/brokers">
                    <Button round color="white">
                      See more...
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6} lg={3}>
              <Card pricing plain>
                <CardBody pricing plain>
                  <h6
                    className={`${classes.cardDescription} ${
                      classes.marginBottom20
                    }`}
                  >
                    TRUST
                  </h6>
                  <div className={classes.icon}>
                    <Home className={classes.iconWhite} />
                  </div>
                  <h3 className={`${classes.cardTitleWhite} ${classes.marginTop30}`}>
                    Investors
                  </h3>
                  <p className={classes.cardDescription}>
                    DEAL SOURCING / GENERATING BUSINESS
                  </p>
                  <Link to="/investors">
                    <Button round color="white">
                      See more...
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6} lg={3}>
              <Card pricing plain>
                <CardBody pricing plain>
                  <h6
                    className={`${classes.cardCategory} ${
                      classes.marginBottom20
                    }`}
                  >
                    INTEGRITY
                  </h6>
                  <div className={classes.icon}>
                    <Business className={classes.iconWhite} />
                  </div>
                  <h3
                    className={`${classes.cardTitleWhite} ${
                      classes.marginTop30
                    }`}
                  >
                    Developers
                  </h3>
                  <p className={classes.cardCategory}>
                    REAL ESTATE INTELLIGENT VISON
                  </p>
                  <Link to="/developers">
                    <Button round color="white">
                      See more...
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6} lg={3}>
              <Card pricing plain>
                <CardBody pricing plain>
                  <h6
                    className={`${classes.cardCategory} ${
                      classes.marginBottom20
                    }`}
                  >
                    EXCELLENCE
                  </h6>
                  <div className={classes.icon}>
                    <AccountBalance className={classes.iconWhite} />
                  </div>
                  <h3
                    className={`${classes.cardTitleWhite} ${
                      classes.marginTop30
                    }`}
                  >
                    Relations
                  </h3>
                  <p className={classes.cardCategory}>
                    INTEGRITY, QUALITY, VALUE
                  </p>
                  <Link to="/relations">
                    <Button round color="white">
                      See more...
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Pricing 1 END */}


    </div>
  );
}

export default withStyles(pricingStyle)(SectionPricing);
